import React from "react";
import Button from "@mui/material/Button";
import { Typography, TextareaAutosize } from "@mui/material";
import styled from "styled-components";

const ThemedTextareaAutosize = styled(TextareaAutosize)(
  ({ theme }) => `
  resize: none;
width: 100%;
padding: 0.6rem;
borderRadius: 4px;
border: 1px solid #E8E8E8;
fontFamily: inter;
fontSize: 1.4rem;
lineHeight: 1.5;`
);

const CommonDescription = ({
  minRows = 9,
  isHeadingHidden = false,
  heading = "Description",
  placeholder = "Enter Description",
  isSubmitActive = true,
  onSubmitButton = () => {},
  onChange = () => {},
  descriptionVal,
  descriptionRef,
}) => {
  return (
    <div style={{ marginTop: "1.3rem" }}>
      <Typography
        sx={{
          marginBottom: "1.2rem",
          color: "#7C7C7C",
          fontSize: "1.4rem",
          padding: "-0.1rem -0.1rem",
          display: isHeadingHidden ? "none" : "block",
        }}
      >
        {heading}
      </Typography>

      <ThemedTextareaAutosize
        disabled={false}
        minRows={minRows}
        placeholder={placeholder}
        size="lg"
        value={descriptionVal}
        ref={descriptionRef}
        onChange={onChange}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "1.7rem",
          marginBottom: "1.7rem",
        }}
      >
        <Button
          variant="contained"
          sx={{
            ":hover": {
              bgcolor: "#e85055",
              color: "white",
            },
            width: "max-content",
            textTransform: "none",
            display: "flex",
            backgroundColor: isSubmitActive
              ? "#e85055"
              : "rgba(232, 80, 91, 0.3)",
            // backgroundColor: "#e85055",
            fontSize: "1.2rem",
            padding: "0.8rem 2.7rem",
            boxShadow: "4px 4px 3px rgba(0, 0, 0, 0.25)",
            color: isSubmitActive ? "white" : "#E8505B",
            // color: "white",
            // pointerEvents: !isSubmitActive ? "none" : "inherit",=
          }}
          onClick={onSubmitButton}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default CommonDescription;
